module.exports = __webpack_public_path__ + "static/media/Satoshi-Regular.3adf562e.woff";